<template>
  <div id="title-fields" class="my-3">
    <!-- :append-icon="listIcon" -->
    <v-text-field
      class="input-title"
      :class="{'error-outline': titleError }"
      id="input-title-focus"
      :value="title"
      autofocus
      @click:append="/*toggleList(!showList)*/"
      @keyup="handleTitle"
      @keydown.esc="/*toggleList(!showList)*/"
      color="gray"
      :placeholder="$store.state.user.langEng ? 'Article title' : 'Artikel titel'"
      solo
      autocomplete="off"
      :title="$store.langEng ? 'Press ESC to toggle' : 'Tryck ESC för att toggla'"
    ></v-text-field>
    <v-text-field
      class="article-slug"
      :class="{'error-outline': slugError }"
      :value="slug"
      @keyup="handleManualSlug"
      autofocus
      :placeholder="$store.state.user.langEng ? 'Article slug' : 'Artikel slug'"
      solo
      autocomplete="off"
    ></v-text-field>
  </div>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { string_to_slug, Rest } from "@/utils";
import $ from "jquery";

@Component
export default class CreateArticleTitleField extends Vue {
  shouldDisplayList = true;
  title = '';
  slug = '';
  manualSlug = false;

  get article() {
    return this.$store.state.article.currentArticle;
  }

  get slugError() {
    return this.$store.state.article.slugError;
  }

  get titleError() {
    return this.$store.state.article.titleError && !this.title.length;
  }

  set slugError(value) {
    this.$store.commit('setSlugError', value);
  }

  set titleError(value) {
    this.$store.commit('setTitleError', value);
  }

  get showList() {
    return this.$store.state.article.showCreateArticleList;
  }

  get listIcon() {
    if (!this.title) return "";
    return this.showList ? "keyboard_arrow_down" : "keyboard_arrow_right";
  }

  handleTitle(e) {
    this.article.title = this.title = e.target.value;
    this.updateSlug();

    // uncomment to display article list on title change
    // if (!this.title) {
    //   this.toggleList(false);
    //   this.shouldDisplayList = true;
    // }

    clearTimeout(this.doSearchTimeout);
    if (this.title) {
      this.doSearchTimeout = setTimeout(() => {

        this.$store.commit("setSearchTerm", this.title);

        // if (this.shouldDisplayList) {
        //   this.toggleList(true);
        //   this.shouldDisplayList = false;
        // }
      }, 300);
    }
  }

  toggleList(val) {
    this.$store.commit('toggleCreateArticleList', val)
  }

  handleManualSlug(e) {
    this.article.slug = this.slug = e.target.value;
    this.slugError = !this.slug.length;
    this.manualSlug = !!this.slug.length;
    if (!this.slugError) {
      this.updateSlug();
    }
  }

  async updateSlug() {
    if (!this.manualSlug) {
      this.article.slug = this.slug = string_to_slug(this.title);
      if (!this.slug) {
        this.slugError = true;
        return;
      }
    }

    if (!this.title) {
      this.titleError = true;
      return;
    }

    const slugTaken = await Rest.get('Article', { properties: { slug: this.slug } });
    this.slugError = (slugTaken.length && slugTaken[0].id != this.article.id) || false;
  }

  @Watch('$route.params.slug')
  async watchSlug(slug) {
    if (slug) {
      this.loadTitleFromSlug(slug);
    }
  }

  @Watch('$store.state.article.didReset')
  async watchDidReset() {
    this.title = '';
    this.slug = '';
    this.slugError = false;
  }

  @Watch('$store.state.article.createArticleSlugToLoad')
  onClickArticleItem(value) {
    if (value) {
      this.slug = value.slug;
      this.title = value.title;
      this.updateSlug();
    }
  }

  @Watch('$store.state.article.forcedNewTitleAndSlug')
  watchForcedNewTitleAndSlug(value) {
    if (value) {
      this.slug = value.slug;
      this.title = value.title;
      !value.init && this.updateSlug();
    }
  }

  async loadTitleFromSlug(slug) {
    const article = await Rest.get('Article', { properties: { slug } });
    if (article.length) {
      this.title = article[0].title;
      this.slug = article[0].slug;
    } else {
      this.article.title = this.title = '';
      this.article.slug = this.slug = '';
      history.replaceState({}, null, "/create-article/");
      this.$store.commit('toggleSnackbar', {
        text: this.$store.state.user.langEng ? 'Invalid article-slug, removing "' + slug + '" from the URL.' : 'Felaktig artikelslug, tar bort "' + slug + '" från URL',
        createSlug: slug
      });
    }
    this.slugError = false;
  }

  mounted() {
    this.slugError = false;
    const clickedArticle = this.$store.state.article.createArticleSlugToLoad;
    if (clickedArticle) {
      this.slug = clickedArticle.slug;
      this.title = clickedArticle.title;
    } else if (this.$route.params.slug) {
      this.loadTitleFromSlug(this.$route.params.slug);
    } else if (this.article.slug) {
      this.slug = this.article.slug;
      this.title = this.article.title;
    }

    $(".article-slug").on("focusout", e => {
      if (e.target.value) {
        this.handleManualSlug(e)
      }
    });

    $("#input-title-focus").focus();

    this.shouldDisplayList = !this.$route.params.slug;
  }

  beforeDestroy() {
    $(".article-slug").off("focusout");
  }
}
</script>

<style>
</style>
